module.exports = __webpack_public_path__ + "static/media/4.5f724bf5.svg";